import { createMuiTheme } from "@material-ui/core/styles";

import background from "../assets/images/background@3x.png";

import {
  blueLight,
  blueDark,
  orangeLight,
  orange,
  orangeDark,
  greenLight,
  green,
  greenDark,
  redLight,
  red,
  redDark,
  white,
  forest,
} from "./variables";

export default createMuiTheme({
  overrides: {
    MuiCssBaseline: {
      "@global": {
        body: {
          background: `url("${background}") no-repeat fixed center`,
          backgroundSize: "contain",
        },
      },
    },
  },
  palette: {
    primary: {
      light: blueLight,
      main: forest,
      dark: blueDark,
    },
    secondary: {
      light: orangeLight,
      main: orange,
      dark: orangeDark,
      contrastText: white,
    },
    success: {
      light: greenLight,
      main: green,
      dark: greenDark,
    },
    error: {
      light: redLight,
      main: red,
      dark: redDark,
    },
    warning: {
      light: orangeLight,
      main: orange,
      dark: orangeDark,
    },
  },
  typography: {
    fontFamily: "Montserrat",
    body1: {
      fontWeight: "bold",
      fontSize: "16px",
    },
    button: {
      fontWeight: "bold",
      textTransform: "none",
    },
  },
  props: {
    MuiInputLabel: {
      shrink: true,
    },
  },
});
